import React from "react";
import { Button, SxProps, Theme } from "@mui/material";
 
interface MyButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  loading?: boolean;
  loadingIndicator?: React.ReactNode;
  loadingPosition?: "start" | "end" | "center";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: "contained" | "outlined" | "text";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  fullWidth?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  sx?: SxProps<Theme>;
}

const MyButton: React.FC<MyButtonProps> = ({
  children,
  onClick,
  loading = false,
  startIcon,
  endIcon,
  variant = "contained",
  color = "primary",
  fullWidth = false,
  disabled = false,
  type = "button",
  sx = {},
}) => {

  return (
    <Button
      onClick={onClick}
      variant={variant}
      loading={loading}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      type={type}
      sx={{
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default MyButton;